import React from 'react';
import { useMutation } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import toast from 'react-hot-toast';
import FrontError from 'helpers/errors/front.error';

interface UpdateButtonProps {
  mutation: DocumentNode;
  successMessage: string;
  errorMessage: string;
  buttonMessage: string;
}

const UpdateButton = ({
  mutation,
  successMessage,
  errorMessage,
  buttonMessage
}: UpdateButtonProps) => {
  const [updateNote, { loading, error }] = useMutation(mutation, {
    onCompleted: () => {
      toast.success(successMessage);
    },
    onError: e => {
      toast.error(e.message);
    }
  });

  return (
    <>
      {!error && (
        <ButtonWithText
          content={buttonMessage}
          onClick={updateNote}
          loading={loading}
        />
      )}
      {error && (
        <ErrorContainer
          text={errorMessage}
          detailErr={new FrontError('Update', error)}
        />
      )}
    </>
  );
};

export default UpdateButton;
